module.exports = __webpack_public_path__ + "media/assets/img/ibis-060bdbd8130b2bfffbc9870c0f9199a4.svg";